import type { DNDState, Node, ParentData, NodeData } from "./types";

export const state: DNDState = {
  activeNode: undefined,
  enterCount: 0,
  clonedDraggedNodes: Array<HTMLElement>(),
  direction: undefined,
  draggedNode: undefined,
  draggedNodes: Array<Node>(),
  dropZones: new WeakMap<HTMLElement, HTMLElement>(),
  dropped: false,
  hiddenNodes: new WeakMap<HTMLElement, Array<Node>>(),
  initialParent: undefined,
  initialParentValues: [],
  lastCoordinates: {
    x: 0,
    y: 0,
  },
  lastParent: undefined,
  lastValue: undefined,
  leftParent: false,
  longTouch: false,
  longTouchTimeout: undefined,
  nodeData: new WeakMap<Element, NodeData>(),
  parentData: new WeakMap<HTMLElement, ParentData>(),
  parentObservers: new WeakMap<HTMLElement, MutationObserver>(),
  parents: new WeakSet<Node>(),
  preventEnter: false,
  removeDraggable: undefined,
  scrollParent: undefined,
  scrollParentOverflow: undefined,
  touchMoving: false,
  selectedNodes: Array<Node>(),
  selectedValues: Array<any>(),
  touchEnded: false,
  touchedNode: undefined,
  touchStartLeft: undefined,
  touchStartTop: undefined,
};
